export default __webpack_public_path__ + "static/media/slide3.e0a6e70e.jpg";